export default __webpack_public_path__ + "static/img-about-1-29c91ffbc687fc7ca0d7a8acd7fb71e3.gif";